import React from 'react';
import QuestionLabel from './QuestionLabel';
import { FormPart, optionAttributes, part } from '~/lib/FormCssApi';

const YesnoQuestion = ({ value, label, setValue, settings, id }) => {
    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                {[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' },
                ].map(option => (
                    <label
                        key={option.value}
                        {...optionAttributes({
                            value: option.value,
                            isSelected: value === option.value,
                        })}
                        className="block"
                    >
                        <input
                            {...part(FormPart.OPTION_INPUT)}
                            className="mr-2"
                            type="radio"
                            name={id}
                            value={option.value}
                            checked={value === option.value}
                            onChange={e => setValue(e.target.value)}
                        />
                        <span {...part(FormPart.OPTION_LABEL)}>
                            {option.label}
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default YesnoQuestion;
